import { render, staticRenderFns } from "./BranchHelplist.vue?vue&type=template&id=49034e9e&"
import script from "./BranchHelplist.vue?vue&type=script&lang=js&"
export * from "./BranchHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports